import React from 'react';
import { Color, Radius } from 'views/constants';
import styled from '@emotion/styled';

type Border = {
  color?: Color;
  width?: string;
  radius?: Radius;
  style?: string;
};

interface StyledImageProps {
  width?: string;
  border?: Border;
  onClick?(): void;
}

const StyledImage = styled.img<StyledImageProps>`
  width: ${({ width }): string => width || '100%'};
  height: inherit;
  border-width: ${({ border }): string => border?.width || 'medium'};
  border-color: ${({ border }): string => border?.color || ''};
  border-radius: ${({ border }): string => border?.radius || '0'};
  border-style: ${({ border }): string => border?.style || 'none'};
  cursor: ${({ onClick }): string => (onClick ? 'pointer' : 'inherit')};
`;

interface ImageProps {
  src: string;
  alt?: string;
  role?: string;
  border?: Border;
  onClick?(): void;
}

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  role,
  border,
  onClick,
}) => (
  <StyledImage
    src={src}
    alt={alt}
    role={role}
    border={border}
    onClick={onClick}
  />
);
